/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Show_MoreInputs */

const en_pc_show_more = /** @type {(inputs: Pc_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show more`)
};

const ar_pc_show_more = /** @type {(inputs: Pc_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض المزيد`)
};

const bn_pc_show_more = /** @type {(inputs: Pc_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আরও দেখান`)
};

const de_pc_show_more = /** @type {(inputs: Pc_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr anzeigen`)
};

const es_pc_show_more = /** @type {(inputs: Pc_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar más`)
};

const fr_pc_show_more = /** @type {(inputs: Pc_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher plus`)
};

const pt_pc_show_more = /** @type {(inputs: Pc_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar mais`)
};

const zh_pc_show_more = /** @type {(inputs: Pc_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示更多`)
};

const tr_pc_show_more = /** @type {(inputs: Pc_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha fazlasını göster`)
};

const ru_pc_show_more = /** @type {(inputs: Pc_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать больше`)
};

const pl_pc_show_more = /** @type {(inputs: Pc_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokaż więcej`)
};

/**
* | output |
* | --- |
* | "Show more" |
*
* @param {Pc_Show_MoreInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const pc_show_more = /** @type {((inputs?: Pc_Show_MoreInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Show_MoreInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_pc_show_more(inputs)
	if (locale === "bn") return bn_pc_show_more(inputs)
	if (locale === "de") return de_pc_show_more(inputs)
	if (locale === "es") return es_pc_show_more(inputs)
	if (locale === "fr") return fr_pc_show_more(inputs)
	if (locale === "pt") return pt_pc_show_more(inputs)
	if (locale === "zh") return zh_pc_show_more(inputs)
	if (locale === "tr") return tr_pc_show_more(inputs)
	if (locale === "ru") return ru_pc_show_more(inputs)
	if (locale === "pl") return pl_pc_show_more(inputs)
	return en_pc_show_more(inputs)
});